import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../../Components/Base/CustomButton";
import InputTextBox from "../../Components/Base/InputTextBox";
import Image from "../../Components/Base/Image";
import Loader from "../../Components/Loder";
import ToolBar from "../../Components/ToolBar/ToolBar";
import AppContext from "../../Context/AppContext";
import { RestReportBean } from "../../Ds/client_ds";
import PageBar from "../../Components/ToolBar/PageBar";
import {
    AllFabricATSInquiryCriteriaBean,
    RestPageListBean,
    RestFabricStyleATSListRequest,
    AllFabricStyleATSInfoDetailsPrintRequest,
    SKUBatchInventorySearchCriteria,
    RestSkuBatchInventoryListRequest,
    VendorPurchaseOnOrderSearchCriteria,
    RestVendorPurchaseOnOrderListRequest,
    CustomerSalesOnOrderSearchCriteria,
    RestCustomerSalesOnOrderListRequest,
    RestFabricStyleListBeanRequest,
    RestReadRequest,
    FabricStyleSearchCriteria,
} from "../../Ds/ds";
import service from "../../Services/Service";
import {
    TOAST_ERROR,
    TOAST_SUCESS,
    TOAST_WARN,
} from "../../Utils/appConstants";
import {
    ColumnDefinition,
    isEmpty,
    isEmptyArray,
    isEmptyString,
} from "../../Utils/util";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import Modal from "../../Components/Modal";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import MobileCardTable from "../../Components/MobileCardTable";

// ─────────────────────────────────────────────────────────────────────
// OnHand line detail modal content
// ─────────────────────────────────────────────────────────────────────
const OnHandQtyDetails = ({ onHandQtyLines }) => {
    const Columns = () => {
        const columns = new Array();
        columns.push(
            new ColumnDefinition()
                .setDetails("RollSKU#", "rollSkuNumber", true)

                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Location", "locationCode", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("Roll#", "rollNumber", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Box#", "boxNumber", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        ); columns.push(
            new ColumnDefinition()
                .setDetails("Lot#", "lotNumber", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("BinLoc#", "aisleInfoText", true,)

                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("OnHandQty", "onHandQuantity", true, true)
                .setStyleDetails("right", "", "", "wt-2", "wt-2")
        );

        // columns.push(
        //   new ColumnDefinition()
        //     .setDetails("", "", true)
        //     .setGraphDetails(true, this.graphValueProvider)
        //     .setStyleDetails("center", "", "", "wt-2", "wt-2")
        // );

        return columns;
    };

    return (
        <div className="model-fw">
            <CustomTable columns={Columns} data={onHandQtyLines} />
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────
// Customer OnOrder  Quantity detail modal content
// ─────────────────────────────────────────────────────────────────────
const CustomerOnOrderQtyDetails = ({ customerOnOrderLines }) => {
    const Columns = () => {
        const columns = new Array();
        columns.push(
            new ColumnDefinition()
                .setDetails("Customer#", "customerCode", true)
                .setStyleDetails("left", "5", "", "wt-3", "wt-3")
            // .setClickDetails(true, false, this.viewCustomerModule, null)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("CustomerName", "customerName", true)
                .setStyleDetails("left", "8", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("OpenOrderQty", "onOrderQuantity", true, true)
                .setStyleDetails("right", "", "", "wt-2", "wt-2")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("CustomerPO#", "customerPONumber", true)
                .setStyleDetails("left", "", "", "wt-4", "wt-4")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("SalesOrder#", "salesOrderNumber", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
            // .setClickDetails(true, false, this.viewSalesModule, null)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("S.O Date", "salesOrderDate", true)
                .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("SO StartDate", "salesOrderStartDate", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );

        return columns;
    };

    return (
        <div className="model-fw">
            <CustomTable columns={Columns} data={customerOnOrderLines} />
        </div>
    );
};


// ─────────────────────────────────────────────────────────────────────
// OnHand line detail modal content
// ─────────────────────────────────────────────────────────────────────
const VendorOnOrderQtyDetails = ({ vendorOnOrderLines }) => {
    const Columns = () => {
        const columns = new Array();
        columns.push(
            new ColumnDefinition()
                .setDetails(" Vendor#", "vendorCode", true)
                .setStyleDetails("left", "8", "", "wt-3", "wt-3")
            // .setClickDetails(true, false, this.viewVendorModule, null)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("VendorName", "vendorName", true)
                .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("PO#", "purchaseOrderNumber", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
            // .setClickDetails(true, false, this.viewPoModule, null)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("OrderStopDate", "purchaseOrderStopDate", true)
                .setStyleDetails("left", "", "", "wt-1", "wt-1")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Open OrderQty", "onOrderQuantity", true, true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("OrderDate", "purchaseOrderStartDate", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
        );
        return columns;
    };

    return (
        <div className="model-fw">
            <CustomTable columns={Columns} data={vendorOnOrderLines} />
        </div>
    );
};


// ─────────────────────────────────────────────────────────────────────
// Main component
// ─────────────────────────────────────────────────────────────────────
export default function ATSInquiry() {
    const { token, setisSessionExpeired, session } = useContext(AppContext);
    const [dataList, setDataList] = useState([]);
    const [criteria, setCriteria] = useState(new AllFabricATSInquiryCriteriaBean());

    const title = "ATS Inquiry";

    // ── Filter state ──

    const [fabricStyleCode, setFabricStyleCode] = useState("");
    const [fabricStyleColorCode, setFabricStyleColorCode] = useState("");
    const [onHandQtyLines, setOnHandQtyLines] = useState([]);
    const [vendorOnOrderLines, setVendorOnOrderLines] = useState([]);
    const [customerOnOrderLines, setCustomerOnOrderLines] = useState([]);


    const [isShowOnHandModel, setIsShowOnHandModel] = useState(false);
    const [isShowVenOnOrderModel, setIsShowVenOnOrderModel] = useState(false);
    const [isShowCustOnOrderModel, setIsShowCustOnOrderModel] = useState(false);

    // ── Pagination / UI state ──
    const [page, setPage] = useState(1);

    const [maxPage, setMaxPage] = useState(1);

    const [isLoading, setIsLoading] = useState(false);
    const [isShowPdf, setIsShowPdf] = useState(false);
    const [isShowExcel, setIsShowExcel] = useState(false);
    const [disable, setDisable] = useState(false);
    const [isAccessible, setIsAccessible] = useState(false);

    const [view, setView] = useState(1); // 1 = list, 2 = grid

    // ── Mobile filter sheet ──
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const isEntityUser = !isEmptyString(session?.entityCode);



    const inputRef = useRef(null);
    const buttonRef = useRef(null);
    const criteriaRef = useRef(null);



    // ── Fabric/Item lookup state ───────────────────────────────────────────────
    const [fabric, setFabric] = useState([]);
    const fabricStyleCodeRef = useRef(null);
    // Replaced external FabricStyleLookupHandler with inline FabricStyleLookupModal
    const [isFabricLookupOpen, setIsFabricLookupOpen] = useState(false);
    const [fabricPageListForAutoCompleteList, setFabricPageListForAutoCompleteList] = useState([]);
    // Start as false — the dropdown must be hidden until the user actually types
    const [showAutoCompleteFabricCodeList, setShowAutoCompleteFabricCodeList] = useState(false);
    const [isAllowFabricRead, setIsAllowFabricRead] = useState(false);
    // const criteriaRef = useRef(null);

    const colorCodeRef = useRef(null);
    // Populated after readFabricByCode returns fabricStyle.colors
    const [colorList, setColorList] = useState([]);

    const [fabricColorPageListForAutoCompleteList, setFabricColorPageListForAutoCompleteList] = useState([]);
    // Start as false — the dropdown must be hidden until the user actually types
    const [showAutoCompleteFabricColorCodeList, setShowAutoCompleteFabricColorCodeList] = useState(false);
    // ── Lifecycle ──
    useEffect(() => {
        setFocus();
        asignDefault();
        // loadPage(1);
    }, []);

    useEffect(() => {
        function handleResize() {
            setView(window.innerWidth <= 768 ? 1 : 2);
            setIsMobile(window.innerWidth <= 768);

        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        // clearAll()
        let criteria = new AllFabricATSInquiryCriteriaBean();
        criteria.companyCode = process.env.REACT_APP_COMPANY;
        criteria.riskvalue = 3;
        setFabricStyleCode("");

        if (!isEmpty(session)) {
            const { entityCode } = session;
            if (!isEmptyString(entityCode)) {
                setFabricStyleCode(entityCode);
                criteria.fabricStyleCode = entityCode;
            }
        }
        setCriteria(criteria);
    }, isFilterOpen);
    // ── Helpers ──
    const setFocus = () => { if (inputRef.current) inputRef.current.focus(); };

    const notify = (type, msg, theme) => {
        if (type === 1) toast.info(msg, { theme });
        else if (type === 2) toast.error(msg, { theme });
        else if (type === 3) toast.success(msg, { theme });
        else if (type === 4) toast.warn(msg, { theme });
        else toast(msg);
    };

    const errorCallBack = (error) => {
        setIsLoading(false);
        notify(TOAST_ERROR, error.message);
    };

    const asignDefault = () => {
        const _criteria = new AllFabricATSInquiryCriteriaBean();
        _criteria.companyCode = process.env.REACT_APP_COMPANY;
        if (!isEmpty(session)) {
            const { entityCode } = session;
            if (!isEmptyString(entityCode)) {
                _criteria.fabricStyleCode = entityCode;
                setFabricStyleCode(entityCode);
            }
        }
        criteriaRef.current = _criteria;
        setCriteria(_criteria);
    };



    // ── Response handlers ──

    // onHand Qty Response
    const handleOnHandQtyDetailsResponse = (response) => {
        // console.log("onHandQty response:", response);
        let msg = "";
        let msg_List = [];
        if (!isEmpty(response.data)) {
            if (response.data.isSessionExpired) {
                setisSessionExpeired(true);
            } else if (response.data.isSuccess) {
                if (!isEmpty(response.data.skuBatchInventoryPageList) && !isEmptyArray(response.data.skuBatchInventoryPageList.skuBatchInventories)) {
                    setOnHandQtyLines(response.data.skuBatchInventoryPageList.skuBatchInventories);
                    setIsShowOnHandModel(true);
                }
                if (!isEmptyArray(response.data.infos)) {
                    response.data.infos.map((info) => msg_List.push(info.messageDescription));
                    notify(TOAST_SUCESS, msg_List.toString());
                }
            } else {
                if (!isEmptyArray(response.data.errors)) {
                    response.data.errors.map((error) => msg_List.push(error.messageDescription));
                    notify(TOAST_ERROR, msg_List.toString());
                }
            }
        }
        setIsLoading(false);
    };

    // onHand Qty Response
    const handleCustomerOnOrderQtyDetailsResponse = (response) => {
        // console.log("CustomerOnOrderQty response:", response);
        let msg = "";
        let msg_List = [];
        if (!isEmpty(response.data)) {
            if (response.data.isSessionExpired) {
                setisSessionExpeired(true);
            } else if (response.data.isSuccess) {
                if (!isEmpty(response.data.orderDetailsResult) && !isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
                    setCustomerOnOrderLines(response.data.orderDetailsResult.onOrderInfoDetails);
                    setIsShowCustOnOrderModel(true);
                }
                if (!isEmptyArray(response.data.infos)) {
                    response.data.infos.map((info) => msg_List.push(info.messageDescription));
                    notify(TOAST_SUCESS, msg_List.toString());
                }
            } else {
                if (!isEmptyArray(response.data.errors)) {
                    response.data.errors.map((error) => msg_List.push(error.messageDescription));
                    notify(TOAST_ERROR, msg_List.toString());
                }
            }
        }
        setIsLoading(false);
    };

    // Vendor Onorder Qty Response
    const handleVendorOnOrderQtyDetailsResponse = (response) => {
        // console.log("VendorOnOrdeQty response:", response);
        let msg = "";
        let msg_List = [];
        if (!isEmpty(response.data)) {
            if (response.data.isSessionExpired) {
                setisSessionExpeired(true);
            } else if (response.data.isSuccess) {
                if (!isEmpty(response.data.orderDetailsResult) && !isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
                    setVendorOnOrderLines(response.data.orderDetailsResult.onOrderInfoDetails);
                    setIsShowVenOnOrderModel(true);
                }
                if (!isEmptyArray(response.data.infos)) {
                    response.data.infos.map((info) => msg_List.push(info.messageDescription));
                    notify(TOAST_SUCESS, msg_List.toString());
                }
            } else {
                if (!isEmptyArray(response.data.errors)) {
                    response.data.errors.map((error) => msg_List.push(error.messageDescription));
                    notify(TOAST_ERROR, msg_List.toString());
                }
            }
        }
        setIsLoading(false);
    };



    const onCriteriaChange = (e) => {

        const { name, value } = e.target;
        const updated = {
            ...criteriaRef.current, // ✅ correct source
            [name]: value,
        };
        criteriaRef.current = updated;
        setCriteria(updated);
        //   setFabricStyleCode(e.target.value);
    };

 
    const handleReportResponse = (response) => {
        let msg_List = [];
        if (response.data != null) {
            if (response.data.isSessionExpired) {
                setisSessionExpeired(true);
            } else if (response.data.isSuccess) {
                if (response.data.reportResult != null) {
                    if (!isEmptyString(response.data.reportResult.reportFileID)) {
                        window.open(
                            `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                            response.data.reportResult.reportFileID
                        );
                    }
                }
                if (!isEmptyArray(response.data.infos)) {
                    response.data.infos.map((info) => msg_List.push(info.messageDescription));
                    notify(TOAST_SUCESS, msg_List.toString());
                }
            } else {
                if (!isEmptyArray(response.data.errors)) {
                    response.data.errors.map((error) => msg_List.push(error.messageDescription));
                    notify(TOAST_ERROR, msg_List.toString());
                }
            }
        }
        setIsLoading(false);
    };

    const handleResponse = (response) => {
        // console.log("ats response...", response);
        let msg_List = [];
        if (!isEmpty(response.data)) {
            if (response.data.sessionExpired) {
                setisSessionExpeired(true);
            } else if (response.data.success) {
                if (
                    !isEmpty(response.data.inquiryResult) &&
                    !isEmptyArray(response.data.inquiryResult.atsInfos)
                ) {
                    const atsData = response.data.inquiryResult.atsInfos;
                    
                    setDataList(atsData);

                    if (!isEmptyArray(response.data.infos)) {
                        response.data.infos.map((info) => msg_List.push(info.messageDescription));
                    }
                }
                if (
                    !isEmpty(response.data.inquiryResult) &&
                    isEmptyArray(response.data.inquiryResult.atsInfos)
                ) {
                    notify(TOAST_WARN, "No Data Found");
                }
            } else {
                if (!isEmptyArray(response.data.errors)) {
                    response.data.errors.map((error) => msg_List.push(error.messageDescription));
                    notify(TOAST_ERROR, msg_List.toString());
                }
            }
        }
        setIsLoading(false);
    };

    // ── API calls ──
    const loadPage = (id) => {

        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
            setDataList([]);
            setIsLoading(true);
            const criteria = new AllFabricATSInquiryCriteriaBean();
            criteria.companyCode = process.env.REACT_APP_COMPANY;

            let temp_Criteria = criteriaRef.current;
            if (!isEmptyString(fabricStyleCode) && !isEmptyString(fabricStyleColorCode)) {
                temp_Criteria.fabricStyleCode = fabricStyleCode;
                temp_Criteria.fabricStyleColorCode = fabricStyleColorCode;
            }
            temp_Criteria.riskvalue = criteriaRef.current.riskvalue;
            let pageInput = new RestPageListBean();
            // pageInput.pageSize = 50;
            pageInput.currentPage = id;
            let listRequest = new RestFabricStyleATSListRequest();
            listRequest.searchCriteria = temp_Criteria;
            listRequest.pageInput = pageInput;

            // console.log("listRequest:", listRequest);
            service(token, "inquireAllFabricStyleATSInfos", listRequest, handleResponse, errorCallBack);
        } else {
            setIsAccessible(true);
        }
    };

    const generateReport = (type, code) => {
        const request = new AllFabricStyleATSInfoDetailsPrintRequest();
        const reportBean = new RestReportBean();
        let criterias = criteria;
        criterias.companyCode = process.env.REACT_APP_COMPANY;
        reportBean.reportType = type;
        request.criteria = criteria;
        request.reportBean = reportBean;
        service(token, "generateAllFabricStyleATSInfoDetailsPrintReport", request, handleReportResponse, errorCallBack);
    };

    // ── Button handlers ──
    const ExecuteHandler = () => {

        // use setTimeout so criteriaRef is updated before loadPage reads it
        setTimeout(() => loadPage(1), 0);
    };

    const buttonHandler = () => ExecuteHandler();
    const loadFirst = () => loadPage(1);
    const loadLast = () => loadPage(maxPage);
    const loadPrevious = () => { if (page > 1) loadPage(parseInt(page) - 1); };
    const loadNext = () => { if (maxPage > page) loadPage(parseInt(page) + 1); };

    const PDFHandler = (code) => {
        if (SecurityAccessManager.AllFabricATSInquiryPDFReport_IsAccessible()) {
            setIsLoading(true);
            generateReport(1, code);
        } else { setIsAccessible(true); }
    };


    const closeModal = () => {
        setIsShowOnHandModel(false);
        setIsShowCustOnOrderModel(false);
        setIsShowVenOnOrderModel(false);
    }
    const onClose = () => setIsAccessible(false);

    const ResetHandler = () => {
        setDataList([]);
        setDisable(false);
        setIsShowExcel(false);
        setIsShowPdf(false);

        let criteria = new AllFabricATSInquiryCriteriaBean();
        criteria.companyCode = process.env.REACT_APP_COMPANY;
        criteria.riskvalue = 3;

        // Set entity code if applicable
        if (!isEmpty(session)) {
            const { entityCode } = session;
            if (!isEmptyString(entityCode)) {
                criteria.fabricStyleCode = entityCode;
            }
        }

        // Clear filter fields
        setFabricStyleCode(!isEmpty(session) && !isEmptyString(session.entityCode) ? session.entityCode : "");
        setFabricStyleColorCode("");

        criteriaRef.current = criteria;
        setCriteria(criteria);

        // Clear color list and dropdowns
        setColorList([]);
        setFabricColorPageListForAutoCompleteList([]);
        setShowAutoCompleteFabricColorCodeList(false);

        setFocus();
    };

    const listViewHandler = () => setView(1);
    const gridViewHandler = () => setView(2);


    const riskValueHandler = (column, row, risk) => {
        if (risk === 1) {
            return "bg-yellow risk-value";
        } else if (risk === 2) {
            return "bg-pink risk-value";
        } else if (risk === 3) {
            return "bg-red risk-value";
        } else if (risk === 0) {
            return "bg-green risk-value";
        }
    };

    const fabricImageHandler = (column, row, imagePath) => {
        if (!imagePath) return null;
        const fullUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH}${imagePath}`;
        return (
            <Image
                url={fullUrl}
                altName={`${row.fabricStyleCode} - ${row.fabricStyleColorCode} image`}
            />
        );
    };

    const viewFabricModule = () => {
        //
    };

    const onHandQuantityClick = (code, e, row) => {
        setIsLoading(true);
        const qtyCriteria = new SKUBatchInventorySearchCriteria();
        qtyCriteria.companyCode = process.env.REACT_APP_COMPANY;
        qtyCriteria.fabricStyleCode = row.fabricStyleCode;
        qtyCriteria.colorCode = row.fabricStyleColorCode;
        qtyCriteria.fetchQuantityAvailableLinesOnly = true;
        let pageInput = new RestPageListBean();
        const request = new RestSkuBatchInventoryListRequest();
        request.pageInput = pageInput;
        request.searchCriteria = qtyCriteria;
        service(token, "getSkuBatchInventoryPageList", request, handleOnHandQtyDetailsResponse, errorCallBack);
    };

    const customerOnOrderQtyClick = (code, e, row) => {
        setIsLoading(true);
        const qtyCriteria = new CustomerSalesOnOrderSearchCriteria();
        qtyCriteria.companyCode = process.env.REACT_APP_COMPANY;
        qtyCriteria.fabricStyleCode = row.fabricStyleCode;
        qtyCriteria.colorCode = row.fabricStyleColorCode;
        const request = new RestCustomerSalesOnOrderListRequest();
        request.pageInput = new RestPageListBean();
        request.searchCriteria = qtyCriteria;
        // console.log("customer qty request :", request);
        service(token, "getCustomerSalesOnOrderDetailsForFabricStyleStatistics", request, handleCustomerOnOrderQtyDetailsResponse, errorCallBack);

    }

    const vendorOnOrderQtyClick = (code, e, row) => {
        setIsLoading(true);
        const qtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
        qtyCriteria.companyCode = process.env.REACT_APP_COMPANY;
        qtyCriteria.fabricStyleCode = row.fabricStyleCode;
        qtyCriteria.colorCode = row.fabricStyleColorCode;
        const request = new RestVendorPurchaseOnOrderListRequest();
        request.pageInput = new RestPageListBean();
        request.searchCriteria = qtyCriteria;
        service(token, "getVendorPurchaseOnOrderDetailsForFabricStyleStatistics", request, handleVendorOnOrderQtyDetailsResponse, errorCallBack);

    }

    const last3MonthQtyClick = () => {
        //
    }

    const last6MonthQtyClick = () => {
        //
    }

    const last12MonthQtyClick = () => {
        //
    }

    const last18MonthQtyClick = () => {
        //
    }

    const last24MonthQtyClick = () => {
        //
    }
    const last36MonthQtyClick = () => {
        //
    }



    // ── Table columns ──
    const Columns = () => {
        const _columns = [];
        _columns.push(new ColumnDefinition().setDetails("Fabric#", "fabricStyleCode", true)
            .setStyleDetails("left", "", "", "wt-4", "wt-4")
            .setClickDetails(false, false, viewFabricModule, null));

        // Image column
        // const imgCol = new ColumnDefinition()
        //     .setDetails("Image", "fabricStyleColorImagePath", true)
        //     .setStyleDetails("left", "", "", "wt-4", "wt-4");
        // imgCol.isImage = true;
        // imgCol.getImage = fabricImageHandler;
        // // console.log("Image column config:", { isImage: imgCol.isImage, accessor: imgCol.accessor, getImage: !!imgCol.getImage });
        // _columns.push(imgCol);
        _columns.push(new ColumnDefinition().setDetails("Image", "fabricStyleImagePath", true)
            .setStyleDetails("center", "", "", "wt-2", "wt-2")
             .setImageDetails(true));


        _columns.push(new ColumnDefinition().setDetails("Name", "fabricStyleName", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
        _columns.push(new ColumnDefinition().setDetails("Color", "fabricStyleColorCode", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
        // _columns.push(new ColumnDefinition().setDetails("ClrName", "fabricStyleColorName", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));

        _columns.push(new ColumnDefinition().setDetails("OnHand", "onHandQuantity", true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(true, false, onHandQuantityClick, null));

        _columns.push(new ColumnDefinition().setDetails("CustOnOrder", "customerOnOrderQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(true, false, customerOnOrderQtyClick, null));

        _columns.push(new ColumnDefinition().setDetails("VndrOnOrder", "vendorOnOrderQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(true, false, vendorOnOrderQtyClick, null));

        //working in process For MobileCard
        _columns.push(new ColumnDefinition().setDetails("Risk", "riskValue", true)
            .setStyleDetails("center", "", "", "wt-2", "wt-2")
            .setGraphDetails(true, riskValueHandler));

        _columns.push(new ColumnDefinition().setDetails("3mnth", "last3MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(false, false, last3MonthQtyClick, null));

        _columns.push(new ColumnDefinition().setDetails("6mnth", "last6MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(false, false, last6MonthQtyClick, null));


        _columns.push(new ColumnDefinition().setDetails("12mnth", "last12MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(false, false, last12MonthQtyClick, null));


        _columns.push(new ColumnDefinition().setDetails("18mnth", "last18MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(false, false, last18MonthQtyClick, null));


        _columns.push(new ColumnDefinition().setDetails("24mnth", "last24MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4").setClickDetails(false, false, last24MonthQtyClick, null));


        _columns.push(new ColumnDefinition().setDetails("36mnth", "last36MonthsSalesQuantity", true, true)
            .setStyleDetails("right", "", "", "wt-4", "wt-4")
            .setClickDetails(false, false, last36MonthQtyClick, null)
        );

        return _columns;
    };


    // ── Fabric/Item lookup handlers ────────────────────────────────────────────
    const onFabricCodeChange = (e) => {
        const fabricStyleCode = e.target.value.toUpperCase();
        if (!fabricStyleCode) {
            // Field cleared — hide dropdown
            setShowAutoCompleteFabricCodeList(false);
            setFabricPageListForAutoCompleteList([]);
            setIsAllowFabricRead(false);
        } else {
            // Characters typed — show dropdown and kick off the search-as-you-type call
            setShowAutoCompleteFabricCodeList(true);
            readFabricBySearchString(fabricStyleCode);   // pass the already-uppercased value
            setIsAllowFabricRead(false);
        }
        setCriteria((prev) => {
            const next = { ...prev, [e.target.name]: fabricStyleCode };
            if (!fabricStyleCode) {
                // Item/Fabric cleared — clear the corresponding color code too
                next.fabricStyleColorCode = "";
            }

            criteriaRef.current = next;
            return next;
        });
    };

    const onfabricBlur = (e) => {
        // On blur, do a direct style read to validate the typed code —
        // mirrors the readandsetFabricStyleDetail call triggered by blur in
        // SalesOrderMaintenanceModule (the same RestReadRequest / readFabricStyle flow).
        setTimeout(() => {
            if (!isAllowFabricRead && e.target.value) {
                readFabricByCode(e.target.value);
            }
        }, 100);
    };

    const onfabricKeyDown = (e) => {
        // F2 (113) or Escape (27) — allow direct read, suppress blur autocomplete
        if (e.keyCode === 113 || e.keyCode === 27) {
            setIsAllowFabricRead(true);
        }
    };

    const fabricenterKeyEventHandler = (e) => {
        const fabricStyleCode = e.target.value;
        setShowAutoCompleteFabricCodeList(false);
        setFabricPageListForAutoCompleteList([]);
        setIsAllowFabricRead(false);
        setCriteria((prev) => {
            const next = { ...prev, fabricStyleCode: fabricStyleCode.toUpperCase() };
            criteriaRef.current = next;
            return next;
        });
        // On Enter, do a direct read via readFabricStyle to validate the code —
        // mirrors fabricenterKeyEventHandler → readandsetFabricStyleDetail in
        // SalesOrderMaintenanceModule.
        if (fabricStyleCode) readFabricByCode(fabricStyleCode);
        // Advance focus to the Color field
        setTimeout(() => {
            if (colorCodeRef.current) colorCodeRef.current.focus();
        }, 0);
    };

    // Called when user picks a row inside FabricStyleLookupModal
    const onFabricLookupSelect = (item) => {

        setCriteria((prev) => {
            const next = { ...prev, fabricStyleCode: item.code };
            criteriaRef.current = next;
            return next;
        });
        setFabricPageListForAutoCompleteList([]);
        setShowAutoCompleteFabricCodeList(false);
        setIsAllowFabricRead(false);
        readFabricByCode(item.code);
        // Move focus to color field
        setTimeout(() => {
            if (colorCodeRef.current) colorCodeRef.current.focus();
        }, 0);
    };
    // Mirrors readandsetFabricStyleDetail() in SalesOrderMaintenanceModule:
    //   • Builds RestReadRequest with companyCode, code, isLoadChildren=true
    //   • Calls FabricStyleService.readFabricStyle
    //   • On success: reads response.data.fabricStyle to confirm the style exists
    //   • On error: silently clears the autocomplete list (no blocking alert)
    const readFabricByCode = (fabricStyleCode) => {
        if (!fabricStyleCode) return;
        const input = new RestReadRequest();
        input.companyCode = process.env.REACT_APP_COMPANY;
        input.code = fabricStyleCode.toUpperCase();
        input.isLoadChildren = true;
        service(token, "readFabricStyle",
            input,
            (response) => {
                // console.log("readFabricByCode response:", response);
                const fabricStyle = response?.data?.fabricStyle;
                if (!fabricStyle) {
                    setFabricPageListForAutoCompleteList([]);
                    setColorList([]);
                    setShowAutoCompleteFabricColorCodeList(false);
                    return;
                }
                // ── Populate color dropdown from fabricStyle.colors ────────────────
                // Mirrors fabricStyleSelected() in SalesOrderMaintenanceModule:
                //   builds a list of { code, description } from active colors.
                const colors = fabricStyle.colors || [];
                // console.log("colors...", colors);
                const activeColors = colors
                    // .filter((c) => c.isActive)
                    .map((c) => ({
                        code: c.fabricStyleColorCode,
                        description: c.fabricStyleColorName || c.fabricStyleColorCode,
                    }));

                setFabric(fabricStyle);
                    // console.log("colors...activeColors", activeColors);
                if (activeColors.length === 1) {
                    // Auto-select the only active color
                    setCriteria((prev) => {
                        const next = { ...prev, fabricStyleColorCode: activeColors[0].code };
                        criteriaRef.current = next;
                        return next;
                    });
                    setColorList([]);
                    setShowAutoCompleteFabricColorCodeList(false);
                } else {
                    setColorList(activeColors);
                    // Show the dropdown only if there are multiple colors and no value typed yet
                    setShowAutoCompleteFabricColorCodeList(activeColors.length > 0);
                }
            },
            (error) => {
                setFabricPageListForAutoCompleteList([]);
                setColorList([]);
                notify(TOAST_ERROR, error.message);
            },
        );
    };

    const displayAutoCompleteFabricCodeList = (show) => {
        setShowAutoCompleteFabricCodeList(show);
    };

    const readFabricBySearchString = (searchString) => {
        const searchCriteria = new FabricStyleSearchCriteria();
        searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
        // Code prefix must be uppercase to hit the server index; name search is case-tolerant
        searchCriteria.fabricStyleCodeStartsWith = searchString.toUpperCase();
        searchCriteria.fabricStyleNameStartsWith = searchString;
        const pageInput = new RestPageListBean();
        pageInput.pageSize = 100;
        const input = new RestFabricStyleListBeanRequest();
        input.companyCode = process.env.REACT_APP_COMPANY;
        input.pageInput = pageInput;
        input.code = searchString.toUpperCase();
        input.searchCriteria = searchCriteria;
        service(
            token,
            "getActiveFabricStylesForAutoComplete",
            input,
            (response) => {
                const styles = response?.data?.fabricStylePageList?.fabricStyles || [];
                const list = styles
                    .filter((s) => s.isActive)
                    .map((s) => ({ code: s.fabricStyleCode, description: s.fabricStyleName }));
                setFabricPageListForAutoCompleteList(list);
            },
            // Search-as-you-type errors should clear silently, not toast the user
            () => setFabricPageListForAutoCompleteList([]),
        );
    };


    /**********************Color onchange */

    const onFabricColorCodeChange = (e) => {
        const fabricStyleColorCode = e.target.value.toUpperCase();
        if (!fabricStyleColorCode) {
            // Field cleared — hide dropdown
            setShowAutoCompleteFabricColorCodeList(false);
            setFabricColorPageListForAutoCompleteList([]);

        } else {
            // Characters typed — show dropdown and kick off the search-as-you-type call
            setShowAutoCompleteFabricColorCodeList(true);
            readFabricColorBySearchString(fabricStyleColorCode);   // pass the already-uppercased value
        }
        setCriteria((prev) => {
            const next = { ...prev, fabricStyleColorCode: fabricStyleColorCode };
            criteriaRef.current = next;
            return next;
        });
    };

    const fabricColorenterKeyEventHandler = (e) => {
        const fabricStyleColorCode = e.target.value;
        setShowAutoCompleteFabricColorCodeList(false);
        setFabricPageListForAutoCompleteList([]);
        setCriteria((prev) => {
            const next = { ...prev, fabricStyleColorCode: fabricStyleColorCode };
            criteriaRef.current = next;
            return next;
        });

    };
    const displayAutoCompleteFabricColorCodeList = (show) => {
        setShowAutoCompleteFabricColorCodeList(show);
    };

    const readFabricColorBySearchString = (searchString) => {
        const searchStringUpper = searchString.toUpperCase();
        // console.log("colorList...", colorList);
        const filteredColors = colorList.filter((color) =>
            color.code.toUpperCase().includes(searchStringUpper) ||
            color.description.toUpperCase().includes(searchStringUpper)
        );
        // console.log("colorList...filteredColors", filteredColors);
        setFabricColorPageListForAutoCompleteList(filteredColors);
    };
    const onFabricColorLookupSelect = (item) => {
        // console.log("item...", item)
        setCriteria((prev) => {
            const next = { ...prev, fabricStyleColorCode: item.code };
            criteriaRef.current = next;
            return next;
        });
        setFabricColorPageListForAutoCompleteList([]);
        setShowAutoCompleteFabricColorCodeList(false);
    };
    return (
        <>
            {isLoading ? <Loader /> : null}

            {/* ── OnHandQtyDetail modal ── */}
            <Modal isOpen={isShowOnHandModel} onClose={closeModal} title="OnHand Quantity Lines">
                <OnHandQtyDetails onHandQtyLines={onHandQtyLines} />
            </Modal>

            {/* ── CustomerDetail modal ── */}
            <Modal isOpen={isShowCustOnOrderModel} onClose={closeModal} title="Customer OnOrder  Quantity Lines">
                <CustomerOnOrderQtyDetails customerOnOrderLines={customerOnOrderLines} />
            </Modal>

            {/* ── VendorDetail modal ── */}
            <Modal isOpen={isShowVenOnOrderModel} onClose={closeModal} title="Vendor OnOrder Lines">
                <VendorOnOrderQtyDetails vendorOnOrderLines={vendorOnOrderLines} />
            </Modal>

            {/* ── Toolbar ── */}
            <ToolBar
                title={title}
                ResetHandler={ResetHandler}
                ExecuteHandler={ExecuteHandler}
                isShowPdf={isShowPdf}
                isShowExcel={isShowExcel}
            />

            {!isMobile && (
                <div className="card-body">
                    <div className="row" style={{ flexWrap: "wrap", gap: "8px", alignItems: "flex-start" }}>

                        {/* Item */}
                        {!isEntityUser && (

                            <div className="form-group" style={{ flex: "1 1 10px", minWidth: 0 }}>
                              
                                <InputTextBox
                                    onKeyDown={onfabricKeyDown}
                                    onValueChangeOnBlur={onfabricBlur}
                                    valueChangeOnBlur={true}
                                    inputRef={fabricStyleCodeRef}
                                    name="fabricStyleCode"
                                    onChange={onFabricCodeChange}
                                    value={criteria.fabricStyleCode}
                                    enterKeyHandler={fabricenterKeyEventHandler}
                                    autoCompleteListData={fabricPageListForAutoCompleteList}
                                    enableAutoCompleteTextBox={true}
                                    displayAutoCompleteList={displayAutoCompleteFabricCodeList}
                                    showAutoCompleteList={showAutoCompleteFabricCodeList}
                                    isMandatory={true}
                                    label="Item / Fabric"
                                    placeholder="Item/Fabric"
                                    lookupList={fabricPageListForAutoCompleteList}
                                    showLookupDropdown={showAutoCompleteFabricCodeList && fabricPageListForAutoCompleteList.length > 0}
                                    onLookupSelect={(item) => onFabricLookupSelect(item)}
                                    onHideLookupDropdown={() => setShowAutoCompleteFabricCodeList(false)}
                                    disable={disable}
                                />
                            </div>



                        )}



                        {/* Color */}
                        <div className="form-group" style={{ flex: "1 1 10px", minWidth: 0 }}>


                            <InputTextBox
                                valueChangeOnBlur={true}
                                inputRef={colorCodeRef}
                                name="fabricStyleColorCode"
                                onChange={onFabricColorCodeChange}
                                value={criteria.fabricStyleColorCode}
                                enterKeyHandler={fabricColorenterKeyEventHandler}
                                autoCompleteListData={fabricColorPageListForAutoCompleteList}
                                enableAutoCompleteTextBox={true}
                                displayAutoCompleteList={displayAutoCompleteFabricColorCodeList}
                                showAutoCompleteList={showAutoCompleteFabricCodeList}
                                isMandatory={true}
                                label="Color"
                                placeholder="Color"
                                lookupList={fabricColorPageListForAutoCompleteList}
                                showLookupDropdown={showAutoCompleteFabricColorCodeList && fabricColorPageListForAutoCompleteList.length > 0}
                                onLookupSelect={(item) => onFabricColorLookupSelect(item)}
                                onHideLookupDropdown={() => setShowAutoCompleteFabricColorCodeList(false)}
                                disable={disable}
                            />
                          
                        </div>
                        {/* Risk */}
                        <div className="form-group" style={{ flex: "1 1 10px", minWidth: 0 }}>
                            <select

                                onChange={onCriteriaChange}
                                name="riskvalue"
                                value={criteria.riskvalue}
                                style={{
                                    width: "100%", height: "36px", borderRadius: "6px",
                                    border: "1px solid var(--color-border-tertiary, #dddddf)",
                                    background: "var(--color-background-primary, #f4f4f7)",
                                    color: "var(--color-text-primary, #181819)",
                                    padding: "0 8px", fontSize: "13px",
                                }}
                            >
                                {/* <option value={""}></option> */}
                                <option value={3}>Critical Risk</option>
                                <option value={2}>High Risk</option>
                                <option value={1}>Moderate Risk</option>
                                <option value={0}>No Risk</option>
                            </select>
                        </div>


                        {/* Buttons */}
                        <div className="form-group col-fit btn-group" style={{ flexShrink: 0 }}>
                            <CustomButton buttonHandler={buttonHandler} disable={disable} buttonRef={buttonRef} label="Fetch" />
                            <CustomButton buttonHandler={ResetHandler} label="Reset" />
                        </div>

                    </div>
                </div>
            )}


            {isMobile && (
                <div className="module-filter-mobile mobile-filter-bar">
                    {!isEntityUser ? (
                        <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
                                stroke="currentColor" strokeWidth="2.2">
                                <line x1="2" y1="4" x2="14" y2="4" />
                                <line x1="4" y1="8" x2="12" y2="8" />
                                <line x1="6" y1="12" x2="10" y2="12" />
                            </svg>
                            Filters

                        </button>
                    ) : (
                        <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
                                stroke="currentColor" strokeWidth="2.2">
                                <line x1="2" y1="4" x2="14" y2="4" />
                                <line x1="4" y1="8" x2="12" y2="8" />
                                <line x1="6" y1="12" x2="10" y2="12" />
                            </svg>
                            Filters

                        </button>
                    )}
                    <div style={{ display: "flex", gap: "8px" }}>
                        <button className="mobile-action-btn" onClick={buttonHandler}>Fetch</button>
                        <button className="mobile-action-btn outline" onClick={ResetHandler}>Reset</button>
                    </div>
                </div>
            )}


            {isMobile && (
                <div className="module-filter-mobile" style={{ flexDirection: "column", width: "100%" }}>



                    {isFilterOpen && (
                        <div className="mobile-filter-overlay" onClick={() => setIsFilterOpen(false)} />
                    )}


                    <div className={`mobile-filter-sheet${isFilterOpen ? " is-open" : ""}`}>
                        <div className="mobile-sheet-handle" />


                        <div className="mobile-sheet-header">
                            <span className="mobile-sheet-title">Filters</span>
                            <div className="mobile-sheet-header-actions">
                                <button className="mobile-sheet-clear" onClick={() => {
                                    asignDefault()
                                }}>Clear all</button>
                                <button className="mobile-sheet-close" onClick={() => setIsFilterOpen(false)}>×</button>
                            </div>
                        </div>


                        <div className="mobile-sheet-body">


                            <div className="mobile-filter-row">
                                <span className="mobile-filter-label">Item</span>
                                <InputTextBox
                                    value={criteria.fabricStyleCode}
                                    name="fabricStyleCode"
                                    placeholder="Enter Item"
                                    disable={isEntityUser}
                                    onChange={(e) => onCriteriaChange(e)}

                                />
                            </div>


                            <div className="mobile-filter-row">
                                <span className="mobile-filter-label">Color</span>
                                <InputTextBox
                                    value={criteria.fabricStyleColorCode}
                                    name="fabricStyleColorCode"
                                    placeholder="Enter Color"
                                    disable={isEntityUser}
                                    onChange={(e) => onCriteriaChange(e)}

                                />
                            </div>

                            <div className="mobile-filter-row">
                                <span className="mobile-filter-label">Risk</span>
                                <select
                                    onChange={onCriteriaChange}
                                    name="riskvalue"
                                    value={criteria.riskvalue}
                                    disabled={isEntityUser}
                                    style={{
                                        width: "100%",
                                        height: "36px",
                                        borderRadius: "6px",
                                        border: "1px solid var(--color-border-tertiary, #dddddf)",
                                        background: "var(--color-background-primary, #f4f4f7)",
                                        color: "var(--color-text-primary, #181819)",
                                        padding: "0 8px",
                                        fontSize: "13px",
                                    }}
                                >
                                    <option value={3}>Critical Risk</option>
                                    <option value={2}>High Risk</option>
                                    <option value={1}>Moderate Risk</option>
                                    <option value={0}>No Risk</option>
                                </select>
                            </div>



                        </div>

                        <button className="mobile-sheet-apply" onClick={() => {
                            setIsFilterOpen(false);

                            setTimeout(() => loadPage(1), 0);
                        }}>
                            Apply Filters
                        </button>
                    </div>

                </div>
            )}

            {/* ── Pagination ── */}
            {/* {!isEmptyArray(dataList) && (
                <PageBar
                    loadFirst={loadFirst}
                    loadNext={loadNext}
                    loadPrevious={loadPrevious}
                    loadLast={loadLast}
                    page={page}
                />
            )} */}

            {/* ── View toggle ── */}
            {!isEmptyArray(dataList) && (
                <ViewToggle
                    listViewHandler={listViewHandler}
                    gridViewHandler={gridViewHandler}
                />
            )}

            {/* ── Results table / card list ── */}
            {!isEmptyArray(dataList) && (
                <div className="card-body ats-results-card">
                    <div className="card-title">
                        <h1>ATS Details</h1>
                    </div>
                    <div className="list-wrap ats-results-wrap">
                        {view === 1 ? (
                            <CustomTable
                                columns={Columns()}
                                data={dataList}
                                isShowFullScreen={true}
                            />
                        ) : (
                            <MobileCardTable
                                columns={Columns()}
                                data={dataList}
                                codeAccessor="code"
                                graphAccessor="riskValue"
                                maxDesktopColumns={3}
                                className="ats-card-table"
                            // subAccessor="customerName"
                            // dateAccessor="createdDate"
                            // statusAccessor="orderStatus"
                            // onPDF={(row) => PDFHandler(row.code)}
                            // onMoreOption={(row) => MoreOptionHandler(row.code)}
                            />
                        )}
                    </div>
                </div>
            )}

            <InValidAccess isShow={isAccessible} clickHandler={onClose} />
        </>
    );
}